import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
const CarouselPagination = ({ selectedItemIndex, itemsNumber, onClick, }) => {
    return (_jsx("div", { className: "control-dots", children: Array(itemsNumber)
            .fill(0)
            .map((_, index) => {
            const isSelected = index === selectedItemIndex;
            const key = `${_}${index}`;
            const ariaLabel = `image item ${index + 1}`;
            const dotClassName = classNames("dot", isSelected && "selected");
            return (_jsx("button", { type: "button", onClick: onClick(index), className: dotClassName, "aria-label": ariaLabel }, key));
        }) }));
};
export default CarouselPagination;
